import styled from "styled-components/macro";

export const InputWrapper = styled.div`
  box-sizing: border-box;
  display: block;
  width: 100%;
  position: relative;
  background: linear-gradient(
    -2deg,
    #ffffff 60%,
    #fdfdfd,
    #fbfbfc,
    #f8f9fa,
    #f6f7f8
  );
  border-radius: 7px;
  border: 1px solid #98a4a5;
  padding: 6px 6px 4px;
`;
